import { render, staticRenderFns } from "./AnnotationGroupSelector.vue?vue&type=template&id=7b101c30&scoped=true"
import script from "./AnnotationGroupSelector.vue?vue&type=script&lang=js"
export * from "./AnnotationGroupSelector.vue?vue&type=script&lang=js"
import style0 from "./AnnotationGroupSelector.vue?vue&type=style&index=0&id=7b101c30&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b101c30",
  null
  
)

export default component.exports